import { Link } from "react-router-dom";

export default function SecurityTab() {
  return (
    <div className="space-y-4 max-w-[800px]">
      <div>
        <h2 className="text-lg font-semibold text-text-primary">安全设置</h2>
        <p className="text-xs text-text-muted mt-0.5">
          Forex 子域不再单独维护安全策略，统一进入全局系统管理配置。
        </p>
      </div>

      <div className="bg-white rounded-lg border border-surface-border p-6">
        <div className="flex items-start gap-4">
          <div className="flex h-10 w-10 shrink-0 items-center justify-center rounded-lg bg-brand/10 text-brand">
            <i className="ri-shield-check-line text-xl" />
          </div>
          <div className="min-w-0 space-y-3">
            <div>
              <h3 className="text-sm font-semibold text-text-primary">已合并到全局系统管理</h3>
              <p className="mt-1 text-xs leading-5 text-text-secondary">
                会话管理、登录锁定、双因素认证、IP 访问控制、密码策略和审计保留均属于整个管理后台的统一安全策略。
                Forex 页面不提供本地保存入口，避免出现子域配置与全局配置不一致。
              </p>
            </div>

            <div className="rounded-lg border border-surface-border bg-surface/50 px-3 py-2 text-xs text-text-muted">
              当前页仅保留去重复说明；如需调整安全策略，请在全局系统管理页面修改并由后端配置接口生效。
            </div>

            <Link
              to="/system-config"
              className="inline-flex items-center gap-1.5 rounded-lg bg-brand px-4 py-2 text-xs font-medium text-white transition-colors hover:bg-brand/90 whitespace-nowrap"
            >
              <i className="ri-settings-3-line text-sm" />
              前往全局系统管理
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}
